import {
  AfterContentInit,
  Component,
  computed,
  OnDestroy,
  signal,
  Signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { AccountingApiService } from '../../../../../_services/accounting-service/accounting-api/accounting-api.service';
import { Router, RouterLink } from '@angular/router';
import { AccountingService } from '../../_services/accounting/accounting.service';
import { AccountingAccount, AccountingProviderCompany } from '../../../../../_interfaces/accounting.interface';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';
import { NgOptimizedImage } from '@angular/common';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { AccountingSelectors } from '../../../../../store/accounting/accounting.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contra-accounts',
  imports: [LoaderComponent, RouterLink, NgOptimizedImage, NgbTooltip],
  templateUrl: './contra-accounts.component.html',
})
export class ContraAccountsComponent implements AfterContentInit, OnDestroy {
  readonly store = inject(Store);
  readonly accountingService = inject(AccountingService);
  readonly accountingApiService = inject(AccountingApiService);
  readonly router = inject(Router);

  readonly sourceAccount$ = this.store.select(AccountingSelectors.sourceAccount);
  readonly sourceAccount = toSignal(this.sourceAccount$, { initialValue: undefined });

  private readonly subscriptions = new Subscription();
  protected readonly AccountingProviderCompany = AccountingProviderCompany;
  protected accountingProvider: Signal<AccountingProviderCompany | undefined> = computed(() =>
    this.accountingService.provider(),
  );

  loading: WritableSignal<boolean> = signal(true);
  failed: WritableSignal<boolean> = signal(false);

  contraAccounts: WritableSignal<AccountingAccount[]> = signal([]);
  providerImgUrl = computed(() => {
    if (this.accountingProvider() === AccountingProviderCompany.XERO) {
      return './assets/accounting-logos/contra-accounts/xero.svg';
    }
    if (this.accountingProvider() === AccountingProviderCompany.QUICKBOOKS) {
      return './assets/accounting-logos/contra-accounts/qb.svg';
    }
    if (this.accountingProvider() === AccountingProviderCompany.SAGE) {
      return './assets/accounting-logos/contra-accounts/sage.svg';
    } else {
      return '';
    }
  });

  ngAfterContentInit(): void {
    this.getContraAccounts();
  }

  getContraAccounts() {
    this.subscriptions.add(
      this.accountingApiService.getAccountingContraAccount().subscribe({
        next: (data) => {
          this.contraAccounts.set(data);
        },
        error: () => {
          this.failed.set(true);
        },
        complete: () => {
          this.loading.set(false);
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
